import api from "./api";
import { APIs } from "../constants/APIConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../constants/PublicVariables";

export default class LiveCaptionAPI {
    storeTranscriptionAPIReq(requestData) {
        return {
            SessionId: GLOBAL_MEETING_DATA.sessionId,
            RoomSid: CALL_DATA.roomSID,
            Messages: requestData,
        };
    }
    storeTranscriptionData(req) {
        return api.postStorageWithoutHeader(APIs.STORE_TRANSCRIPTION_DATA, this.storeTranscriptionAPIReq(req));
    }
}
